// Where a menu opened at a point goes. At the point, down and to the right, the
// way every desktop does it — unless that would run past the window, in which
// case it opens to the left of or above the point instead. When it fits on
// neither side it is pushed back just far enough to be whole on screen, and it
// never comes closer than `margin` to an edge.
export function placeMenu(a: {
  x: number;
  y: number;
  width: number;
  height: number;
  viewportWidth: number;
  viewportHeight: number;
  margin?: number;
}): { left: number; top: number } {
  const margin = a.margin ?? 8;
  return {
    left: along(a.x, a.width, a.viewportWidth, margin),
    top: along(a.y, a.height, a.viewportHeight, margin),
  };
}

function along(point: number, size: number, room: number, margin: number): number {
  if (point + size <= room - margin) return Math.max(margin, point);
  if (point - size >= margin) return point - size;
  return Math.max(margin, room - margin - size);
}
